import { BrowserRouter, Routes, Route , Navigate} from 'react-router-dom';
import React, { Suspense } from 'react';
import { useSelector } from 'react-redux';
import Index_page from './pages/Index_page';
import './scss/style.scss';

const loading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

// Pages
const Login = React.lazy(() => import('./pages/login_pages/Login_form'))
const Home = React.lazy(() => import('./pages/home/Home'))

const UserList = React.lazy(() => import('./pages/users_pages/Users_table'))
const SingleUser = React.lazy(() => import('./pages/users_pages/Single_UserDetail'))

const TaskList = React.lazy(() => import('./pages/tasks_pages/Tasks_table'))
const SingleTask = React.lazy(() => import('./pages/tasks_pages/Single_TaskDetail'))




const App = () => {

  // Session is rehydrated from localStorage in `store.js` before the first
  // render, so `adminDetail` is either the full admin object or `null` —
  // no need to dispatch from inside App on refresh.
  const adminDetail = useSelector((state) => state.adminDetails);

  const RequireAuth = ({ children }) => {
    return adminDetail ? <Index_page page_route={children} /> : <Navigate to="/login" />;
  };

  
  return (
    <BrowserRouter>
      <Suspense fallback={loading}>
        <Routes>
          <Route path='*' element={<Navigate to={'/'}/>} />
          <Route path="/login" element={<Login />} />

          <Route path="/">
            <Route
              index
              element={
                <RequireAuth>
                  <Home />
                </RequireAuth>
              }
            />
            {/* for user management route */}
            <Route path="/user-management">
              <Route
                index
                element={
                  <RequireAuth>
                    <UserList />
                  </RequireAuth>
                }
              />
              <Route
                path=":userId"
                element={
                  <RequireAuth>
                    <SingleUser />
                  </RequireAuth>
                }
              />
            </Route>

            {/* for task management route (read-only listing + detail) */}
            <Route path="/task-management">
              <Route
                index
                element={
                  <RequireAuth>
                    <TaskList />
                  </RequireAuth>
                }
              />
              <Route
                path=":taskId"
                element={
                  <RequireAuth>
                    <SingleTask />
                  </RequireAuth>
                }
              />
            </Route>

          </Route>
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
